/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { getUsage } from 'redux/reducers/usages';
import { withRouter } from 'react-router-dom';
import actions from 'redux/actions';

import DataLoader from 'components/DataLoader';
import UsageInfo from 'components/UsageInfo';

import styles from './styles.module.scss';

import type { Fetchable, Usage, ReduxState } from 'types';
import type { ContextRouter } from 'react-router-dom';

const mapStateToProps = (state: ReduxState) => {
  return {
    usage: getUsage(state),
  };
};

type Props = ContextRouter & {
  usage: Fetchable<Usage>,
  sessionUsageId: Fetchable<number | void>,
};

class UsageShow extends React.Component<Props, void> {
  _renderUsageShow = data => {
    return (
      <div className={styles.container}>
        <UsageInfo {...data} />
      </div>
    );
  };

  render() {
    const {
      usage: { fetching, error, data },
    } = this.props;
    return (
      <DataLoader loading={fetching} error={error} data={data} render={this._renderUsageShow} />
    );
  }
}

export default withRouter(connect(mapStateToProps, actions)(UsageShow));
